"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSubjectWithoutProductResolving;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _exctractPriceFieldsFromProduct = _interopRequireDefault(require("./exctractPriceFieldsFromProduct"));

var _extractQuantityFieldsFromProduct = _interopRequireDefault(require("./extractQuantityFieldsFromProduct"));

function createSubjectWithoutProductResolving(partial) {
  return (0, _extends2.default)({
    product: null,
    // Enforce validation error if product is not present in partial object.
    quantity: 1,
    price: 0,
    priceOriginal: undefined,
    priceWithTax: 0,
    priceOriginalWitTax: undefined,
    discountAbsolute: undefined,
    discountPercent: undefined
  }, (0, _exctractPriceFieldsFromProduct.default)((partial || {}).product), (0, _extractQuantityFieldsFromProduct.default)((partial || {}).product), partial);
}